import * as React from 'react';
import { css } from '@patternfly/react-styles';
import { DropdownContext } from './dropdownConstants';
export var DropdownGroup = function DropdownGroup(_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label;
  return React.createElement(DropdownContext.Consumer, null, function (_ref2) {
    var sectionClass = _ref2.sectionClass,
        sectionTitleClass = _ref2.sectionTitleClass,
        sectionComponent = _ref2.sectionComponent;
    var SectionComponent = sectionComponent;
    return React.createElement(SectionComponent, {
      className: css(sectionClass, className)
    }, label && React.createElement("h1", {
      className: css(sectionTitleClass),
      "aria-hidden": true
    }, label), React.createElement("ul", {
      role: "none"
    }, children));
  });
};